// // ***** New Balance Recharge Modal (01-07-25) ***** //
// import React, { useState } from "react";
// import { Modal, Button, Form } from "react-bootstrap";
// import { FaMoneyBillWave } from "react-icons/fa";
// import { useTranslation } from "react-i18next";

// const BalanceRechargeModal = ({ isOpen, onClose, servitorId, currentBalance }) => {
//   const { t } = useTranslation("servitor");
//   const [amount, setAmount] = useState("");
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   const handleRecharge = async (e) => {
//     e.preventDefault();
//     setError("");
//     setSuccess("");

//     if (!amount || isNaN(amount) || amount < 10) {
//       setError(t("balanceRecharge.invalidAmount"));
//       return;
//     }

//     try {
//       const response = await fetch(`http://localhost:4001/servitors/${servitorId}/recharge`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//         body: JSON.stringify({ amount: parseFloat(amount) }),
//       });

//       if (response.ok) {
//         setSuccess(t("balanceRecharge.success"));
//         setAmount("");
//         setTimeout(() => {
//           onClose();
//           window.location.reload();
//         }, 1500);
//       } else {
//         const data = await response.json();
//         setError(data.message || t("balanceRecharge.error"));
//       }
//     } catch (err) {
//       setError(t("balanceRecharge.error"));
//       console.error("Error recharging balance:", err);
//     }
//   };

//   const setQuickAmount = (value) => {
//     setAmount(value.toString());
//     setError("");
//   };

//   return (
//     <Modal show={isOpen} onHide={onClose} centered className="servitorbalance-modal">
//       <Modal.Header closeButton>
//         <Modal.Title>
//           <FaMoneyBillWave style={{ marginRight: "8px" }} />
//           {t("balanceRecharge.title")}
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <div className="servitorbalance-current">
//           {t("balanceRecharge.currentBalance")}: <strong>{currentBalance.toLocaleString()} Tk</strong>
//         </div>
//         <Form onSubmit={handleRecharge}>
//           <Form.Group controlId="rechargeAmount" className="mb-3">
//             <Form.Label>{t("balanceRecharge.amountLabel")}</Form.Label>
//             <Form.Control
//               type="number"
//               value={amount}
//               onChange={(e) => setAmount(e.target.value)}
//               placeholder={t("balanceRecharge.amountPlaceholder")}
//               min="10"
//               step="1"
//               aria-label={t("balanceRecharge.amountLabel")}
//               className="servitorbalance-input"
//             />
//           </Form.Group>
//           <div className="servitorbalance-quick-amounts">
//             <Button
//               variant="outline-secondary"
//               onClick={() => setQuickAmount(100)}
//               className="servitorbalance-quick-btn"
//             >
//               100 Tk
//             </Button>
//             <Button
//               variant="outline-secondary"
//               onClick={() => setQuickAmount(500)}
//               className="servitorbalance-quick-btn"
//             >
//               500 Tk
//             </Button>
//             <Button
//               variant="outline-secondary"
//               onClick={() => setQuickAmount(1000)}
//               className="servitorbalance-quick-btn"
//             >
//               1000 Tk
//             </Button>
//           </div>
//           {error && <div className="servitorbalance-error">{error}</div>}
//           {success && <div className="servitorbalance-success">{success}</div>}
//           <Button
//             variant="primary"
//             type="submit"
//             className="servitorbalance-submit-btn"
//             aria-label={t("balanceRecharge.submit")}
//           >
//             {t("balanceRecharge.submit")}
//           </Button>
//         </Form>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={onClose} className="servitorbalance-cancel-btn">
//           {t("balanceRecharge.cancel")}
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default BalanceRechargeModal;














// ***** New Balance Recharge Modal with Payment Gateways (01-07-25) ***** //
// import React, { useState } from "react";
// import { Modal, Button, Form } from "react-bootstrap";
// import { FaMoneyBillWave, FaArrowLeft } from "react-icons/fa";
// import { useTranslation } from "react-i18next";
// import './balanceRecharge.css';
// import { URL } from "../../../../config";

// const BalanceRechargeModal = ({ isOpen, onClose, servitorId, currentBalance, onBalanceUpdated  }) => {
//   const { t } = useTranslation("servitor");
//   const [amount, setAmount] = useState("");
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
//   const [step, setStep] = useState(1); // Step 1: Amount, Step 2: Payment Method
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [isProcessing, setIsProcessing] = useState(false);

//   // ***** Payment Gateway Options ***** //
//   const paymentMethods = [
//     {
//       id: "bkash",
//       name: "bKash",
//       icon: "💳",
//       color: "#E2136E",
//       bgColor: "#FCE4EC",
//       description: t("payment.bkash.description", { defaultValue: "Pay with bKash" })
//     },
//     {
//       id: "nagad",
//       name: "Nagad",
//       icon: "📱", 
//       color: "#F47F20",
//       bgColor: "#FFF3E0",
//       description: t("payment.nagad.description", { defaultValue: "Pay with Nagad" })
//     },
//     {
//       id: "upay",
//       name: "Upay",
//       icon: "💰",
//       color: "#00B4D8", 
//       bgColor: "#E1F5FE",
//       description: t("payment.upay.description", { defaultValue: "Pay with Upay" })
//     },
//     {
//       id: "rocket",
//       name: "Rocket",
//       icon: "🚀",
//       color: "#8E24AA",
//       bgColor: "#F3E5F5", 
//       description: t("payment.rocket.description", { defaultValue: "Pay with Rocket" })
//     }
//   ];

//   const handleRecharge = async (e) => {
//     e.preventDefault();
//     onBalanceUpdated?.();
//     setError("");
//     setSuccess("");
//     setIsProcessing(true);

//     if (!amount || isNaN(amount) || amount < 10) {
//       setError(t("balanceRecharge.invalidAmount"));
//       setIsProcessing(false);
//       return;
//     }

//     if (!selectedPaymentMethod) {
//       setError(t("payment.selectMethod", { defaultValue: "Please select a payment method" }));
//       setIsProcessing(false);
//       return;
//     }

//     try {
//       // Here you would integrate with actual payment gateway
//       const response = await fetch(`${URL}/recharge/initiate`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//         body: JSON.stringify({ 
//           servitorId,
//           amount: parseFloat(amount),
//           paymentMethod: selectedPaymentMethod 
//         }),
//       });

//       if (response.ok) {
//         // setSuccess(t("balanceRecharge.success"));
//         // setAmount("");
//         // setSelectedPaymentMethod("");
//         // setTimeout(() => {
//         //   onClose();
//         //   window.location.reload();
//         // }, 2000);
//         const { url } = await response.json();
//         window.location.href = url; 
//       } else {
//         const data = await response.json();
//         setError(data.message || t("balanceRecharge.error"));
//       }
//     } catch (err) {
//       setError(t("balanceRecharge.error"));
//       console.error("Error recharging balance:", err);
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   const setQuickAmount = (value) => {
//     setAmount(value.toString());
//     setError("");
//   };

//   const handleNextStep = () => {
//     if (!amount || isNaN(amount) || amount < 10) {
//       setError(t("balanceRecharge.invalidAmount"));
//       return;
//     }
//     setError("");
//     setStep(2);
//   };

//   const handleBackStep = () => {
//     setStep(1);
//     setSelectedPaymentMethod("");
//     setError("");
//   };

//   const handleClose = () => {
//     setStep(1);
//     setAmount("");
//     setSelectedPaymentMethod("");
//     setError("");
//     setSuccess("");
//     setIsProcessing(false);
//     onClose();
//   };

//   return (
//     <Modal show={isOpen} onHide={handleClose} centered className="balance-recharge-modal">
//       <Modal.Header closeButton className="balance-modal-header">
//         <Modal.Title className="balance-modal-title">
//           {step === 2 && (
//             <Button 
//               variant="link" 
//               onClick={handleBackStep}
//               className="back-button"
//               aria-label="Go back"
//             >
//               <FaArrowLeft />
//             </Button>
//           )}
//           <FaMoneyBillWave className="title-icon" />
//           {step === 1 ? t("balanceRecharge.title") : t("payment.selectMethod", { defaultValue: "Select Payment Method" })}
//         </Modal.Title>
//       </Modal.Header>

//       <Modal.Body className="balance-modal-body">
//         {/* Current Balance Display */}
//         <div className="current-balance-card">
//           <div className="balance-info">
//             <span className="balance-label">{t("balanceRecharge.currentBalance")}:</span>
//             <span className="balance-amount">৳{currentBalance.toLocaleString()}</span>
//           </div>
//         </div>

//         {/* Step 1: Amount Selection */}
//         {step === 1 && (
//           <div className="amount-selection">
//             <Form.Group controlId="rechargeAmount" className="amount-group">
//               <Form.Label className="amount-label">{t("balanceRecharge.amountLabel")}</Form.Label>
//               <Form.Control
//                 type="number"
//                 value={amount}
//                 onChange={(e) => setAmount(e.target.value)}
//                 placeholder={t("balanceRecharge.amountPlaceholder")}
//                 min="10"
//                 step="1"
//                 className="amount-input"
//               />
//             </Form.Group>

//             {/* Quick Amount Buttons */}
//             <div className="quick-amounts">
//               <h6 className="quick-title">{t("payment.quickAmounts", { defaultValue: "Quick Amounts" })}</h6>
//               <div className="quick-buttons">
//                 {[100, 500, 1000, 2000].map((value) => (
//                   <button
//                     key={value}
//                     type="button"
//                     onClick={() => setQuickAmount(value)}
//                     className={`quick-btn ${amount === value ? 'active' : ''}`}
//                   >
//                     ৳{value}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {error && <div className="error-message">{error}</div>}

//             <Button
//               onClick={handleNextStep}
//               className="next-button"
//               disabled={!amount || amount < 10}
//             >
//               {t("payment.continue", { defaultValue: "Continue" })} →
//             </Button>
//           </div>
//         )}

//         {/* Step 2: Payment Method Selection */}
//         {step === 2 && (
//           <div className="payment-selection">
//             <div className="amount-summary">
//               <span>{t("payment.amountToPay", { defaultValue: "Amount to Pay" })}: </span>
//               <strong>৳{parseFloat(amount).toLocaleString()}</strong>
//             </div>

//             <div className="payment-methods">
//               <h6 className="payment-title">{t("payment.chooseMethod", { defaultValue: "Choose Payment Method" })}</h6>
//               <div className="payment-grid">
//                 {paymentMethods.map((method) => (
//                   <div
//                     key={method.id}
//                     onClick={() => setSelectedPaymentMethod(method.id)}
//                     className={`payment-card ${selectedPaymentMethod === method.id ? 'selected' : ''}`}
//                     style={{ 
//                       borderColor: selectedPaymentMethod === method.id ? method.color : '#e0e0e0',
//                       backgroundColor: selectedPaymentMethod === method.id ? method.bgColor : '#ffffff'
//                     }}
//                   >
//                     <div className="payment-icon" style={{ color: method.color }}>
//                       <span className="method-emoji">{method.icon}</span>
//                     </div>
//                     <div className="payment-info">
//                       <h6 className="method-name" style={{ color: method.color }}>{method.name}</h6>
//                       <p className="method-description">{method.description}</p>
//                     </div>
//                     {selectedPaymentMethod === method.id && (
//                       <div className="selected-indicator" style={{ color: method.color }}>
//                         ✓
//                       </div>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {error && <div className="error-message">{error}</div>}
//             {success && <div className="success-message">{success}</div>}

//             <Button
//               onClick={handleRecharge}
//               className="proceed-button"
//               disabled={!selectedPaymentMethod || isProcessing}
//             >
//               {isProcessing ? (
//                 <>
//                   <span className="spinner"></span>
//                   {t("payment.processing", { defaultValue: "Processing..." })}
//                 </>
//               ) : (
//                 <>
//                   💳 {t("payment.proceedToPay", { defaultValue: "Proceed to Pay" })} ৳{parseFloat(amount).toLocaleString()}
//                 </>
//               )}
//             </Button>
//           </div>
//         )}
//       </Modal.Body>

//       <Modal.Footer className="balance-modal-footer">
//         <Button variant="secondary" onClick={handleClose} className="cancel-button">
//           {t("balanceRecharge.cancel")}
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default BalanceRechargeModal;




// ************* upper code is all okay, that is for payment gateway system ************* //
// Md. Ariful Islam Evan - HelpNao
// ************Update code for handle Manual Recharge system for temporary (4-Dec-2025)********** //
import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaMoneyBillWave, FaArrowLeft, FaPaperPlane } from "react-icons/fa";
import { FaRegCopy } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import "./balanceRecharge.css";
import { URL } from "../../../../config";
import bkashLogo from "../../../../Assets/BkashLogo.png";

const BalanceRechargeModal = ({
  isOpen,
  onClose,
  servitorId, // kept for future, backend uses req.user now
  currentBalance,
  onBalanceUpdated,
}) => {
  const { t } = useTranslation("servitor");

  const [amount, setAmount] = useState("");
  const [step, setStep] = useState(1);
  const [senderMobile, setSenderMobile] = useState("");
  const [senderTrxId, setSenderTrxId] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [copied, setCopied] = useState(false);

  const BKASH_NUMBER = "01828986631";

  const resetState = () => {
    setAmount("");
    setStep(1);
    setSenderMobile("");
    setSenderTrxId("");
    setError("");
    setSuccess("");
    setIsProcessing(false);
    setCopied(false);
  };

  const handleClose = () => {
    resetState();
    onClose?.();

    // ensure scrolling is restored on any close (X or Cancel)
    document.body.style.overflow = "";
    document.body.classList.remove("modal-open");
  };

  const setQuickAmount = (value) => {
    setAmount(value.toString());
    setError("");
  };

  const handleNextStep = () => {
    const amt = parseFloat(amount);
    if (!amt || isNaN(amt) || amt < 10) {
      setError(t("balanceRecharge.invalidAmount"));
      return;
    }
    setError("");
    setStep(2);
  };

  const handleBackStep = () => {
    setStep(1);
    setError("");
    setSuccess("");
  };

  // copy bKash number
  const handleCopyNumber = async () => {
    try {
      await navigator.clipboard.writeText(BKASH_NUMBER);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      setCopied(false);
    }
  };

  const handleSubmitManual = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setIsProcessing(true);

    const amt = parseFloat(amount);
    if (!amt || isNaN(amt) || amt < 10) {
      setError(t("balanceRecharge.invalidAmount"));
      setIsProcessing(false);
      return;
    }

    if (!senderMobile.trim()) {
      setError(
        t("balanceRecharge.senderMobileRequired", {
          defaultValue:
            "Please enter the mobile number you used to send money.",
        })
      );
      setIsProcessing(false);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setError(
          t("balanceRecharge.notLoggedIn", {
            defaultValue: "You must be logged in as servitor.",
          })
        );
        setIsProcessing(false);
        return;
      }

      const res = await fetch(`${URL}/recharge/manual`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          amount: amt,
          senderMobile: senderMobile.trim(),
          senderTrxId: senderTrxId.trim() || undefined,
          paymentMethod: "bkash",
          // servitorId, // backend uses req.user
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || data.message || t("balanceRecharge.error"));
      } else {
        setSuccess(
          t("balanceRecharge.manualSubmitted", {
            defaultValue:
              "Your recharge request has been submitted. Admin will review and approve soon.",
          })
        );

        if (typeof onBalanceUpdated === "function") {
        onBalanceUpdated();
      }

        setTimeout(() => {
          handleClose();
        }, 1000);
      }
    } catch (err) {
      console.error("manual recharge error:", err);
      setError(t("balanceRecharge.error"));
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Modal
      show={isOpen}
      onHide={handleClose}
      centered
      className="balance-recharge-modal"
    >
      <Modal.Header closeButton className="balance-modal-header">
        <Modal.Title className="balance-modal-title">
          {step === 2 && (
            <Button
              variant="link"
              onClick={handleBackStep}
              className="back-button"
              aria-label="Go back"
            >
              <FaArrowLeft />
            </Button>
          )}
          <FaMoneyBillWave className="title-icon" />
          {step === 1
            ? t("balanceRecharge.title")
            : t("balanceRecharge.manualTitle", {
                defaultValue: "Submit Recharge Request",
              })}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="balance-modal-body">
        {/* Current Balance */}
        <div className="current-balance-card">
          <div className="balance-info">
            <span className="balance-label">
              {t("balanceRecharge.currentBalance")}
            </span>
            <span className="balance-amount">
              ৳{Number(currentBalance || 0).toLocaleString()}
            </span>
          </div>
        </div>

        {/* STEP 1 – amount */}
        {step === 1 && (
          <div className="amount-selection">
            <Form.Group controlId="rechargeAmount" className="amount-group">
              <Form.Label className="amount-label">
                {t("balanceRecharge.amountLabel")}
              </Form.Label>
              <Form.Control
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder={t("balanceRecharge.amountPlaceholder")}
                min="10"
                step="1"
                className="amount-input"
              />
            </Form.Group>

            <div className="quick-amounts">
              <h6 className="quick-title">
                {t("payment.quickAmounts", {
                  defaultValue: "Quick Amounts",
                })}
              </h6>
              <div className="quick-buttons">
                {[100, 500, 1000, 2000].map((value) => (
                  <button
                    key={value}
                    type="button"
                    onClick={() => setQuickAmount(value)}
                    className={`quick-btn ${
                      parseFloat(amount) === value ? "active" : ""
                    }`}
                  >
                    ৳{value}
                  </button>
                ))}
              </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            <Button
              onClick={handleNextStep}
              className="next-button"
              disabled={!amount || parseFloat(amount) < 10}
            >
              {t("payment.continue", { defaultValue: "Continue" })} →
            </Button>
          </div>
        )}

        {/* STEP 2 – bKash instructions */}
        {step === 2 && (
          <form onSubmit={handleSubmitManual} className="manual-recharge-form">
            {/* ✅ small selected-amount badge */}
            <div className="amount-summary-badge">
              <span>
                {t("balanceRecharge.selectedAmount", {
                  defaultValue: "Selected amount",
                })}
              </span>
              <strong>
                ৳{parseFloat(amount || "0").toLocaleString()}
              </strong>
            </div>

            <div className="bkash-instruction-card">
              <div className="bkash-header">
                <div className="bkash-logo-wrap">
                  <span className="bkash-logo-text">
                    {t("balanceRecharge.bkashlogo", {
                      defaultValue: "bKash",
                    })}
                  </span>
                  <img
                    src={bkashLogo}
                    alt="bKash"
                    className="bkash-logo-img"
                  />
                </div>
                <span className="bkash-tag">
                  {t("balanceRecharge.manualBkashTitle", {
                    defaultValue: "Send Money with bKash",
                  })}
                </span>
              </div>

              <div className="bkash-number-row">
                <div className="bkash-number-texts">
                  <span className="bkash-number-label">
                    {t("balanceRecharge.targetNumberLabel", {
                      defaultValue: "Send money to this number",
                    })}
                  </span>
                  <span className="bkash-number-value">{BKASH_NUMBER}</span>
                </div>
                <button
                  type="button"
                  className="bkash-copy-btn"
                  onClick={handleCopyNumber}
                >
                  <FaRegCopy className="bkash-copy-icon" />
                  <span>
                    {copied
                      ? t("balanceRecharge.copied", {
                          defaultValue: "Copied",
                        })
                      : t("balanceRecharge.copy", {
                          defaultValue: "Copy",
                        })}
                  </span>
                </button>
              </div>

              <ul className="bkash-steps">
                <li>
                  {t("balanceRecharge.step1", {
                    defaultValue: "Open your bKash app or dial *247#.",
                  })}
                </li>
                <li>
                  {t("balanceRecharge.step2", {
                    defaultValue:
                      "Choose Send Money and enter the number above.",
                  })}
                </li>
                <li>
                  {t("balanceRecharge.step3", {
                    defaultValue:
                      "Enter the amount you want to recharge and confirm.",
                  })}
                </li>
              </ul>
            </div>

            <div className="manual-fields">
              <Form.Group className="mt-2">
                <Form.Label>
                  {t("balanceRecharge.senderMobileLabel", {
                    defaultValue:
                      "Your bKash number (from which you sent money)",
                  })}
                </Form.Label>
                <Form.Control
                  type="text"
                  value={senderMobile}
                  onChange={(e) => setSenderMobile(e.target.value)}
                  placeholder="01XXXXXXXXX"
                />
              </Form.Group>

              <Form.Group className="mt-2">
                <Form.Label>
                  {t("balanceRecharge.trxIdLabel", {
                    defaultValue: "Transaction ID (optional)",
                  })}
                </Form.Label>
                <Form.Control
                  type="text"
                  value={senderTrxId}
                  onChange={(e) => setSenderTrxId(e.target.value)}
                  placeholder="e.g. 7H5F3KLM"
                />
              </Form.Group>
            </div>

            {error && <div className="error-message mt-2">{error}</div>}
            {success && <div className="success-message mt-2">{success}</div>}

            <Button
              type="submit"
              className="proceed-button mt-3"
              disabled={isProcessing}
            >
              {isProcessing ? (
                <>
                  <span className="spinner"></span>
                  {t("payment.processing", {
                    defaultValue: "Processing...",
                  })}
                </>
              ) : (
                <>
                  <FaPaperPlane />
                  {t("balanceRecharge.submitManual", {
                    defaultValue: "Submit Request",
                  })}
                </>
              )}
            </Button>
          </form>
        )}
      </Modal.Body>

      <Modal.Footer className="balance-modal-footer">
        <Button
          variant="secondary"
          onClick={handleClose}
          className="cancel-button"
        >
          {t("balanceRecharge.cancel")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BalanceRechargeModal;
